import React from 'react'
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../api/axiosInstance';
import { FormContext } from '../contexts/FormContext'
import ModifiedForm from '../layout/form/ModifiedForm'
import { TextField } from '../layout/form/TextInputFields';
import ErrorHandler from "../../error-handler/ErrorHandler";

const COMPONENT = "Create-Category: ";

function CreateCategory() {

    const { t } = useTranslation();

    async function submitBank(data) {
        try {
            const res = await axiosInstance.post("/category", data);
            console.log(`${COMPONENT} Res: ${JSON.stringify(res)}`);
            return { type: 1, message: t("success") }
        }
        catch (e) {
            console.error(e);
            return { type: 2, message: e.message }

        }
    }

    return (
        <ModifiedForm
            submitFunction={submitBank}
        >
            <h4 className="title">{t("category.categories")}</h4>

            <div className="styledform">
                <TextField
                    className="formTextField"
                    id={"title_ar"}
                    validation={{
                        required: true,
                    }}
                    title={t("category.titleAR")}
                />
                <TextField
                    className="formTextField"
                    id={"title_en"}
                    validation={{
                        required: true,
                    }}
                    title={t("category.titleEN")}
                />
                <TextField
                    className="formTextField"
                    id={"privs_ar"}
                    validation={{
                        required: true,
                    }}
                    title={t("category.privsAR")}
                />
                <TextField
                    className="formTextField"
                    id={"privs_en"}
                    validation={{
                        required: true,
                    }}
                    title={t("category.privsEN")}
                />
            </div>
            <div className="formSubmit">
                <button className="defaultButton" type="submit" >
                    {t("buttons.finish")}
                </button>
            </div>
        </ModifiedForm>
    )
}

export default ErrorHandler(CreateCategory, axiosInstance);